module.exports = __webpack_public_path__ + "static/img/9.2b1f023e.jpg";